import React from "react";

export function GraphIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3271_30595)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5547 4.02858C16.8151 4.28892 16.8151 4.71103 16.5547 4.97138L10.2214 11.3047C9.96105 11.5651 9.53895 11.5651 9.2786 11.3047L6.41667 8.44279L1.88807 12.9714C1.62772 13.2317 1.20561 13.2317 0.945262 12.9714C0.684913 12.711 0.684913 12.2889 0.945262 12.0286L5.94526 7.02857C6.20561 6.76823 6.62772 6.76823 6.88807 7.02857L9.75 9.8905L15.6119 4.02858C15.8723 3.76823 16.2944 3.76823 16.5547 4.02858Z"
          fill="#E9E9E9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4167 4.49998C11.4167 4.13179 11.7151 3.83331 12.0833 3.83331H16.0833C16.4515 3.83331 16.75 4.13179 16.75 4.49998V8.49998C16.75 8.86817 16.4515 9.16665 16.0833 9.16665C15.7151 9.16665 15.4167 8.86817 15.4167 8.49998V5.16665H12.0833C11.7151 5.16665 11.4167 4.86817 11.4167 4.49998Z"
          fill="#E9E9E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_3271_30595">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.75 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default GraphIcon();
